import { render, staticRenderFns } from "./leaderboardShare.vue?vue&type=template&id=22bc8f47&scoped=true&"
import script from "./leaderboardShare.vue?vue&type=script&lang=js&"
export * from "./leaderboardShare.vue?vue&type=script&lang=js&"
import style0 from "./leaderboardShare.vue?vue&type=style&index=0&id=22bc8f47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bc8f47",
  null
  
)

export default component.exports